import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { IBidPricingResponse, IBidResponse } from "@miplatform/types";

export const usePriceDetailsDrawerViewModel = () => {
  const [priceDetails, setPriceDetails] = useState<IBidPricingResponse | null>(
    null
  );

  const getPriceDetails = async (data: IBidResponse) => {
    const response = await homeService.pricing.plans.getById({
      planAreas: data.planAreas,
      accountId: data.builderId,
    });
    if (response.status === HTTP_STATUSES.OK) {
      setPriceDetails(response.data.planDetails);
    }
  };

  return {
    getPriceDetails,
    priceDetails,
  };
};
